import { render, staticRenderFns } from "./EventStatsCards.vue?vue&type=template&id=4956a21e&scoped=true"
import script from "./EventStatsCards.vue?vue&type=script&lang=js"
export * from "./EventStatsCards.vue?vue&type=script&lang=js"
import style0 from "./EventStatsCards.vue?vue&type=style&index=0&id=4956a21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956a21e",
  null
  
)

export default component.exports